import LoginByGraphIdPage from "pages/LoginPage/LoginByGraphIdPage";
import { useRootStore } from "store/StoreContextProvider";
import PluginTeamsHomePage from "./PluginTeamsHomePage";

export default function HomePageRouter() {
  const { loginStore } = useRootStore();

  return (<>
    {loginStore.currentUser && (
      <PluginTeamsHomePage />
    )}
    {!loginStore.currentUser && (<LoginByGraphIdPage loginPath=""/>)}
    </>
  );
}
